import { signal } from '@preact/signals'

import api from './api'
import { profile } from './session'

// home: undefined while loading, then the /api/home payload. Mutations
// return the same shape under `state`, so they refresh it whole.
export const home = signal(undefined)

function setHome(data) {
  home.value = data
  profile.value = data.profile
}

export async function loadHome() {
  const res = await api.get('/api/home')
  setHome(res)

  return res
}

export async function startWorkout() {
  const res = await api.post('/api/workout/start')
  setHome(res.state)

  return res.result
}

export async function completeWorkout() {
  const res = await api.post('/api/workout/complete')
  setHome(res.state)

  return res.result
}

export async function sendFeedback(rating, comment) {
  const res = await api.post('/api/workout/feedback', { rating, comment })
  setHome(res.state)

  return res.result
}
